
import './App.css';
import Home from './Components/Home/Home';
import Privacidade from './Components/Privacidade/Privacidade';
import NotFound from './Components/NotFound/NotFound';
import ErrorBoundary from './Components/ErrorBoundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div>
        <ErrorBoundary>
          <BrowserRouter>
            <Routes>
                <Route path='/' element={<Home />}></Route>
                <Route path='/eng' element={<Home />}></Route>
                <Route path='/Privacidade' element={<Privacidade />}></Route>
                <Route path='*' element={<Home />}></Route>
                
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
    </div>
  );
}

export default App;
